export default "__VITE_ASSET__Dip9zeUD__"